// extracted by mini-css-extract-plugin
export default {"group":"SidebarFoldableGroup_group__kJ3TJ","expandable":"SidebarFoldableGroup_expandable__-I6fs"};